// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app__instagramSection_container {
  max-width: 100%;
  margin: 0 auto;
  padding: 20px;
  text-align: center;
}

.app__instagramSection_heading {
  font-size: 4rem;
  font-weight: 800;
  line-height: 48px;
  margin: 50px 0;
  font-family: "SawtonIndustrial-Bold";
}

.app__instagramSection_image-container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: center;
  align-items: flex-start;
  padding: 0 200px;
}
.app__instagramSection_image {
  position: relative;
  flex-grow: 1;
  flex-shrink: 0;
  flex-basis: calc(25% - 10px); /* Vier Bilder nebeneinander */
  aspect-ratio: 1/1;
  border-radius: 10px;
  overflow: hidden;
  min-width: 400px;
}

.app__instagramSection_image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.2s, filter 0.2s;
}

.app__instagramSection_image:hover img {
  transform: scale(1.05);
  filter: brightness(0.6); /* Dunklere Darstellung */
}

.app__instagramSection_image::before {
  content: "\\f16d"; /* Instagram Logo (unicode) */
  font-family: "FontAwesome"; /* Verwende die passende Font-Familie */
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 3rem;
  color: white;
  opacity: 0;
  transition: opacity 0.2s;
}

.app__instagramSection_image:hover::before {
  opacity: 1;
}
.instagram-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 3rem;
  color: rgba(255, 255, 255, 0.3);
  opacity: 0.9;
  transition: color 0.2s, opacity 0.2s;
  z-index: 1; /* Damit das Logo über dem Bild angezeigt wird */
}

.app__instagramSection_image:hover img {
  transform: scale(1.1);
  filter: brightness(0.8);
}

.app__instagramSection_image:hover .instagram-icon {
  color: rgba(255, 255, 255, 0.9);
  opacity: 1;
}

@media screen and (max-width: 2100px) {
  .app__instagramSection_image {
    min-width: 250px;
  }
}

@media screen and (max-width: 1500px) {
  .app__instagramSection_image {
    min-width: 350px;
  }
  .app__instagramSection_image-container {
    padding: 0 122px;
  }
}

@media screen and (max-width: 1440px) {
  .app__instagramSection_image {
    min-width: 235px;
  }
}

@media screen and (max-width: 1430px) {
  .app__instagramSection_image {
    flex-grow: 1;
    flex-shrink: 0;
    flex-basis: calc(50% - 10px); /* Zwei Bilder nebeneinander */
    min-width: unset;
  }
  .app__instagramSection_image-container {
    padding: 0 50px;
  }
}

@media screen and (max-width: 800px) {
  .app__instagramSection_image {
    flex-grow: 1;
    flex-shrink: 0;
    flex-basis: calc(50% - 10px); /* Zwei Bilder nebeneinander */
    min-width: unset;
  }
  .app__instagramSection_image-container {
    padding: 0 25px;
  }
}

@media screen and (max-width: 600px) {
  .app__instagramSection_image {
    flex-grow: 1;
    flex-shrink: 0;
    flex-basis: calc(100% - 20px); /* Ein Bild pro Zeile */
    min-width: unset;
  }
  .app__instagramSection_image-container {
    padding: 0 25px;
  }
}

@media screen and (max-width: 450px) {
  .app__instagramSection_heading {
    font-size: 40px;
    font-weight: bold;
    margin: 0 0 50px 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/container/InstagramSection/instagramSection.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,YAA0B;EAA1B,cAA0B;EAA1B,4BAA0B,EAAE,8BAA8B;EAC1D,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,uCAAuC;AACzC;;AAEA;EACE,sBAAsB;EACtB,uBAAuB,EAAE,yBAAyB;AACpD;;AAEA;EACE,gBAAgB,EAAE,6BAA6B;EAC/C,0BAA0B,EAAE,uCAAuC;EACnE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,YAAY;EACZ,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,+BAA+B;EAC/B,YAAY;EACZ,oCAAoC;EACpC,UAAU,EAAE,gDAAgD;AAC9D;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,UAAU;AACZ;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,YAA0B;IAA1B,cAA0B;IAA1B,4BAA0B,EAAE,8BAA8B;IAC1D,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,YAA0B;IAA1B,cAA0B;IAA1B,4BAA0B,EAAE,8BAA8B;IAC1D,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,YAA2B;IAA3B,cAA2B;IAA3B,6BAA2B,EAAE,uBAAuB;IACpD,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;EACpB;AACF","sourcesContent":[".app__instagramSection_container {\n  max-width: 100%;\n  margin: 0 auto;\n  padding: 20px;\n  text-align: center;\n}\n\n.app__instagramSection_heading {\n  font-size: 4rem;\n  font-weight: 800;\n  line-height: 48px;\n  margin: 50px 0;\n  font-family: \"SawtonIndustrial-Bold\";\n}\n\n.app__instagramSection_image-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  justify-content: center;\n  align-items: flex-start;\n  padding: 0 200px;\n}\n.app__instagramSection_image {\n  position: relative;\n  flex: 1 0 calc(25% - 10px); /* Vier Bilder nebeneinander */\n  aspect-ratio: 1/1;\n  border-radius: 10px;\n  overflow: hidden;\n  min-width: 400px;\n}\n\n.app__instagramSection_image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 0.2s, filter 0.2s;\n}\n\n.app__instagramSection_image:hover img {\n  transform: scale(1.05);\n  filter: brightness(0.6); /* Dunklere Darstellung */\n}\n\n.app__instagramSection_image::before {\n  content: \"\\f16d\"; /* Instagram Logo (unicode) */\n  font-family: \"FontAwesome\"; /* Verwende die passende Font-Familie */\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  font-size: 3rem;\n  color: white;\n  opacity: 0;\n  transition: opacity 0.2s;\n}\n\n.app__instagramSection_image:hover::before {\n  opacity: 1;\n}\n.instagram-icon {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  font-size: 3rem;\n  color: rgba(255, 255, 255, 0.3);\n  opacity: 0.9;\n  transition: color 0.2s, opacity 0.2s;\n  z-index: 1; /* Damit das Logo über dem Bild angezeigt wird */\n}\n\n.app__instagramSection_image:hover img {\n  transform: scale(1.1);\n  filter: brightness(0.8);\n}\n\n.app__instagramSection_image:hover .instagram-icon {\n  color: rgba(255, 255, 255, 0.9);\n  opacity: 1;\n}\n\n@media screen and (max-width: 2100px) {\n  .app__instagramSection_image {\n    min-width: 250px;\n  }\n}\n\n@media screen and (max-width: 1500px) {\n  .app__instagramSection_image {\n    min-width: 350px;\n  }\n  .app__instagramSection_image-container {\n    padding: 0 122px;\n  }\n}\n\n@media screen and (max-width: 1440px) {\n  .app__instagramSection_image {\n    min-width: 235px;\n  }\n}\n\n@media screen and (max-width: 1430px) {\n  .app__instagramSection_image {\n    flex: 1 0 calc(50% - 10px); /* Zwei Bilder nebeneinander */\n    min-width: unset;\n  }\n  .app__instagramSection_image-container {\n    padding: 0 50px;\n  }\n}\n\n@media screen and (max-width: 800px) {\n  .app__instagramSection_image {\n    flex: 1 0 calc(50% - 10px); /* Zwei Bilder nebeneinander */\n    min-width: unset;\n  }\n  .app__instagramSection_image-container {\n    padding: 0 25px;\n  }\n}\n\n@media screen and (max-width: 600px) {\n  .app__instagramSection_image {\n    flex: 1 0 calc(100% - 20px); /* Ein Bild pro Zeile */\n    min-width: unset;\n  }\n  .app__instagramSection_image-container {\n    padding: 0 25px;\n  }\n}\n\n@media screen and (max-width: 450px) {\n  .app__instagramSection_heading {\n    font-size: 40px;\n    font-weight: bold;\n    margin: 0 0 50px 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
